import {noteClassification} from './noteClassification';

export const normalizedPointText = text => String(text || '').normalize('NFKC').toLowerCase().replace(/\s+/g, '');
export const pointResolved = point => point?.status === 'resolved' || point?.resolved === true || point?.archived === true;
export function pointCategory(point) {
  const c = noteClassification(point);
  return JSON.stringify([c.scope, c.scope === 'map' ? String(c.mapName || c.mapId).toLowerCase() : '', c.side,
    c.assigneeUids.length ? [...c.assigneeUids].sort() : c.assignees.map(name=>name.toLowerCase()).sort()]);
}
export const pointIdentity = point => `${pointCategory(point)}:${normalizedPointText(point.text)}`;
export const pointSourceKey = point => `${point.sourceScope || point.scope || 'general'}:${point.sourceMapId || point.mapId || ''}:${point.sourceId || point.id}`;
export function similarImprovementPoints(point, points, original) {
  const text = normalizedPointText(point.text);
  if (!text) return [];
  const words = value => new Set(String(value).toLowerCase().split(/\W+/).filter(word=>word.length>2));
  const tokens = words(point.text);
  return points.filter(other => !original || pointSourceKey(other)!==pointSourceKey(original)).filter(other => {
    const candidate = normalizedPointText(other.text);
    if (candidate === text) return true;
    if (Math.min(text.length,candidate.length)>=10 && (candidate.includes(text)||text.includes(candidate))) return true;
    const otherTokens=words(other.text), common=[...tokens].filter(token=>otherTokens.has(token)).length;
    return common>=2 && common / Math.max(1,new Set([...tokens,...otherTokens]).size)>=0.5;
  }).map(other=>({...other,exact:pointIdentity(point)===pointIdentity(other)}));
}
export function improvementPointToFocus(point) {
  return {id:`temp-${crypto.randomUUID()}`, text:point.text, ...noteClassification(point), ratings:{},
    sourceType:'improvement_note',sourceId:point.sourceId || point.id,sourceScope:point.sourceScope || point.scope || 'general',
    sourceMapId:point.sourceMapId || point.mapId || null};
}
